var app = angular.module("nms.dynamicDevice");

app.directive("empty", [
    function() {
        return {
            restrict: "E",
            templateUrl: "templates/features/dynamic-device/domain/yang/leaf/types/empty.html"
        };
    }
]);
